import { FooterStyles } from "../../styles/AppStyles.styles.tw";
export default function Footer() {
    return (
        <FooterStyles>
            <p className='text-center'>&copy; 2024 Cortal Insight. All Rights Reserved.</p>
        </FooterStyles>
    )
}
